import Collection from "../../../data-structures/collection";
import TodoItem from "./todo-item";
import TodoList from "../todo-list/todo-list";


export default class TodoItem_Collection extends Collection<TodoItem> {


    constructor(models: TodoItem[]) {
        super(models);

    }

    static initFromJson(data: JSONArray, todoList: TodoList) {
        const collection = new TodoItem_Collection([])

        _.map(data, (item: JSONObject)=> {
            collection.add(new TodoItem(todoList, item))
        })

        return collection
    }

}
